import { DownloadOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import { debounce } from 'lodash';
import { useEffect, useState } from 'react';

import { Button, SearchInput } from '../../../../components/index';
import { RangePickerStylized } from '../../../../components/common/datepicker/styles';
import { useGetChargeReportQuery } from '../../../../services/chargeApi';
import {
  createDateString,
  createDateStringPtBr,
} from '../../../../utils/utils';
import { SectionHeader } from '../styles';
import { ChargeReportTable } from './chargeReportTable';
import { FilterChargeReportType } from '../../../../typesFinancial';

export function ChargeSection() {
  const [QueryPage, setQueryPage] = useState(1);
  const [QueryPageSize, setQueryPageSize] = useState(15);

  const [Filters, setFilters] = useState<FilterChargeReportType>({
    page_number: QueryPage,
    page_size: 15,
  });

  const { data: chargeReport, isLoading: isLoadingchargeReport } =
    useGetChargeReportQuery(Filters);

  useEffect(() => {
    setFilters((prev) => ({
      ...prev,
      page_number: QueryPage,
      page_size: QueryPageSize,
    }));
  }, [QueryPage, QueryPageSize]);

  function onChangeDatePicker(dates: any) {
    if (dates === null) {
      setFilters((prev) => ({
        complete_filter: prev.complete_filter
          ? prev.complete_filter
          : undefined,
      }));
      return;
    }
    let filteredDates = {};
    if (dates && dates.length > 0 && dates[0]) {
      filteredDates = {
        ...filteredDates,
        initial_date: createDateString(dates[0], true),
      };
    }
    if (dates && dates.length > 1 && dates[1]) {
      filteredDates = {
        ...filteredDates,
        final_date: createDateString(dates[1], true),
      };
    }
    setFilters((prev) => ({ ...prev, ...filteredDates }));
  }

  function onSearch(value: string) {
    if (value !== '') {
      setFilters({ complete_filter: value });
    } else {
      setFilters((prev) => ({ ...prev, complete_filter: undefined }));
    }
  }

  const convertToCSV = (objArray: any) => {
    let str = '';

    for (let i = 0; i < objArray.length; i++) {
      let line = '';
      let index: any;
      for (index in objArray[i]) {
        if (Object.hasOwn(objArray[i], index)) {
          if (line !== '') line += ',';
          let formated_value;
          if (objArray[i][index] == null) {
            line += '';
          } else {
            if (index === 'charge_created_at' || index === 'charge_update_at') {
              formated_value = createDateStringPtBr(objArray[i][index]);
            } else if (index === 'total_value') {
              formated_value = objArray[i][index].toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              });
            }
            line += formated_value || objArray[i][index];
          }
        }
      }
      str += `${line} \r\n`;
    }
    return str;
  };

  const downloadCSV = () => {
    const csvData = new Blob([convertToCSV(chargeReport?.results)], {
      type: 'text/csv',
    });
    const csvURL = URL.createObjectURL(csvData);
    const link = document.createElement('a');
    link.href = csvURL;
    link.download = `relatorio-desempenho-financeiro.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <SectionHeader style={{ flexDirection: 'row', gap: '15px' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            width: '30%',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: '16px',
              marginInlineEnd: '10px',
            }}
          >
            <SearchInput
              size="large"
              allowClear
              placeholder="Pesquisar embarcação/atracação"
              style={{ width: '400px' }}
              onChange={debounce((evt) => onSearch(evt.target.value), 500)}
            />
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            marginRight: 'auto',
            width: '50%',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <span style={{ width: '140px' }}>
              Filtro Por Faturamento:{'   '}
            </span>
            <RangePickerStylized
              allowClear
              onChange={onChangeDatePicker}
              minuteStep={1}
              showTime={false}
              format={['DD/MM/YYYY', 'DD/MM/YYYY']}
              style={{ width: '240px', background: 'var(--neutral_lightest)' }}
            />
          </div>
          <Space size={18}>
            <Button icon={<DownloadOutlined />} onClick={downloadCSV}>
              Download CSV
            </Button>
          </Space>
        </div>
      </SectionHeader>
      <ChargeReportTable
        dataSource={chargeReport?.results}
        totalItems={chargeReport?.count}
        isLoadingChargeReportData={isLoadingchargeReport}
        onChangePagination={setQueryPage}
        onShowSizeChange={setQueryPageSize}
        queryPage={QueryPage}
      />
    </>
  );
}
